/**
 * UI strings for the Draw Studio (cv.*): the on-screen drawing canvas ("Draw on screen instead") —
 * tools, brush sizes, lesson palette, undo / redo / clear, tracing helpers, zoom. `vi` covers every key.
 */
export const en = {
  'cv.tools': 'Drawing tools',
  'cv.tool.pencil': 'Pencil',
  'cv.tool.crayon': 'Crayon',
  'cv.tool.marker': 'Marker',
  'cv.tool.fill': 'Paint bucket',
  'cv.tool.eraser': 'Eraser',
  'cv.tool.picker': 'Colour picker',
  'cv.size': 'Brush size',
  'cv.size.S': 'Small',
  'cv.size.M': 'Medium',
  'cv.size.L': 'Big',
  'cv.size.XL': 'Huge',
  'cv.sizeAny': 'Any size',
  'cv.eraserSize': 'Eraser size',
  'cv.undo': 'Undo',
  'cv.redo': 'Redo',
  'cv.clear': 'Clear page',
  'cv.clearTitle': 'Start a fresh page?',
  'cv.clearBody': "Don't worry: Undo brings your drawing back.",
  'cv.clearYes': 'Clear page',
  'cv.clearNo': 'Keep drawing',
  'cv.undone': 'Undo!',
  'cv.redone': 'Redo!',
  'cv.cleared': 'Fresh page. Tap Undo to bring it back.',
  'cv.nothing': 'Nothing to undo yet',
  'cv.hint': 'Need a hint? Show a faint guide',
  'cv.hintHide': 'Hide the guide',
  'cv.guides': 'Guide lines',
  'cv.guidesOn': 'Drawing guide lines: light lines you can hide later',
  'cv.guidesHide': 'Hide guide lines',
  'cv.guidesShow': 'Show guide lines',
  'cv.compare': 'Compare with the picture',
  'cv.zoomReset': 'Show the whole page',
  'cv.picture': 'Picture colours',
  'cv.basics': 'Crayon box',
  'cv.more': 'More colours',
  'cv.tints': 'Lighter & darker',
  'cv.extra': 'More crayons',
  'cv.wheel': 'Mix a colour',
  'cv.lightness': 'Light or dark',
  'cv.mine': 'My colours',
  'cv.saveMine': 'Save my colour',
  'cv.colour': 'Colour: {name}',
  'cv.now': '{tool}, {size}',
  'cv.pickHint': 'Tap the picture or your drawing to pick a colour',
  'cv.picked': 'Got it: {name}!',
  'cv.fillHint': 'Tap inside a closed shape to fill it',
  'cv.restored': 'Your drawing is still here!',
  'cv.gestures': 'Two fingers: zoom and move · two-finger tap = undo · three-finger tap = redo',
  'cv.close': 'Back to the camera',
  'cv.board': 'Drawing paper',
  'cv.closeSheet': 'Close',
};

export const vi: Record<keyof typeof en, string> = {
  'cv.tools': 'Dụng cụ vẽ',
  'cv.tool.pencil': 'Bút chì',
  'cv.tool.crayon': 'Bút sáp',
  'cv.tool.marker': 'Bút dạ',
  'cv.tool.fill': 'Xô sơn',
  'cv.tool.eraser': 'Cục tẩy',
  'cv.tool.picker': 'Ống hút màu',
  'cv.size': 'Cỡ bút',
  'cv.size.S': 'Nhỏ',
  'cv.size.M': 'Vừa',
  'cv.size.L': 'To',
  'cv.size.XL': 'Rất to',
  'cv.sizeAny': 'Cỡ tuỳ ý',
  'cv.eraserSize': 'Cỡ tẩy',
  'cv.undo': 'Hoàn tác',
  'cv.redo': 'Làm lại',
  'cv.clear': 'Xoá hết',
  'cv.clearTitle': 'Xoá hết để vẽ trang mới?',
  'cv.clearBody': 'Đừng lo: bấm Hoàn tác là tranh quay lại.',
  'cv.clearYes': 'Xoá hết',
  'cv.clearNo': 'Vẽ tiếp',
  'cv.undone': 'Hoàn tác!',
  'cv.redone': 'Làm lại!',
  'cv.cleared': 'Trang mới tinh. Bấm Hoàn tác để lấy lại tranh.',
  'cv.nothing': 'Chưa có gì để hoàn tác',
  'cv.hint': 'Cần gợi ý? Hiện nét mờ',
  'cv.hintHide': 'Ẩn nét mờ',
  'cv.guides': 'Nét phác',
  'cv.guidesOn': 'Đang vẽ nét phác: nét nhạt, lát nữa ẩn đi được',
  'cv.guidesHide': 'Ẩn nét phác',
  'cv.guidesShow': 'Hiện nét phác',
  'cv.compare': 'So với tranh mẫu',
  'cv.zoomReset': 'Xem cả trang',
  'cv.picture': 'Màu của tranh',
  'cv.basics': 'Hộp bút màu',
  'cv.more': 'Thêm màu',
  'cv.tints': 'Nhạt hơn & đậm hơn',
  'cv.extra': 'Thêm bút màu',
  'cv.wheel': 'Tự pha màu',
  'cv.lightness': 'Sáng hay tối',
  'cv.mine': 'Màu của con',
  'cv.saveMine': 'Lưu màu này',
  'cv.colour': 'Màu: {name}',
  'cv.now': '{tool}, {size}',
  'cv.pickHint': 'Chạm vào tranh mẫu hoặc tranh của con để lấy màu',
  'cv.picked': 'Lấy được màu {name}!',
  'cv.fillHint': 'Chạm vào trong một hình kín để tô đầy',
  'cv.restored': 'Tranh của con vẫn còn đây!',
  'cv.gestures': 'Hai ngón: phóng to và kéo · chạm hai ngón = hoàn tác · chạm ba ngón = làm lại',
  'cv.close': 'Quay lại máy ảnh',
  'cv.board': 'Giấy vẽ',
  'cv.closeSheet': 'Đóng',
};
